import React, {useEffect} from 'react';
import {
    Grid,
    IconButton,
    makeStyles
} from '@material-ui/core';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';


const FilterHeader = (props: any) => {
    const {networks, onSelect} = props;
    const classes = useStyles();
    let network: any;
    let id: number;
    let selectedNetwork: number;

    return (
        <Grid
            container
            justify={'space-evenly'}
        >
            { Object.entries(networks).filter((entry: any[]) => {
                id = entry[0];
                network = entry[1];
                if (network.selected) {
                    selectedNetwork = id
                }
                return network.activated;

            }).map((entry: any) =>
                <FilterTab
                    key={entry[0]}
                    id = {entry[0]}
                    network={entry[1]}
                    onSelect={(state: any) => {
                        let updatedState = {
                            [selectedNetwork]:  {
                                ...networks[selectedNetwork],
                                selected: false,
                            },
                            ...state
                        };
                        onSelect({ ...updatedState, selected: Object.keys(state)[0]})
                    }
                    }
                />
            )
            }
            </Grid>
    )
};

const FilterTab = (props: any) => {
    const {network, onSelect, id} = props;
    return (
        <Grid item>
            <IconButton
                onClick={() => {
                    let networkState = {
                        ...network,
                        selected: !network.selected
                    };

                    onSelect({[id]: networkState })
                }}
                style={
                    {
                        color: network.selected == true ? network.iconColor : 'rgba(0, 0, 0, 0.54)'
                    }
                }>
                {network.plainIcon}
            </IconButton>
        </Grid>
    )
};

const useStyles = makeStyles({


});

export default FilterHeader;
